import {
    CREATE_ERP_AGENT,
    ERP_AGENT_REORDER,
    FETCH_ERP_AGENTS,
    FETCH_MAPPED_ERP_CLIENTS,
    FETCH_MAPPED_ERP_TECHNICIANS,
    SET_CUSTOMER_TRACKING_LOADING,
    SET_ERP_AGENT,
    SET_ERP_AGENT_LOADING,
    SET_ERP_AGENTS_LOADING,
    SET_CUSTOMERS_LOADING,
    SET_CUSTOMER_SEARCH_VALUE,
    SET_TECHNICIAN_TRACKING_LOADING,
    SET_TECHNICIANS_LOADING,
    SET_TECHNICIAN_SEARCH_VALUE
} from '../actions/actionTypes';

const initialState = {
    customerTrackingLoading:   false,
    customersLoading:          false,
    customerSearchValue:       '',
    erpAgents:                 [],
    erpClients:                [],
    erpClientsMeta:            {},
    erpTechnicians:            [],
    erpTechniciansMeta:        {},
    newErpAgent:               {},
    erpAgentLoading:           false,
    selectedAgent:             {},
    erpAgentsLoading:          false,
    techniciansLoading:        false,
    technicianSearchValue:     '',
    technicianTrackingLoading: false,
    updatedAt:                 null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CREATE_ERP_AGENT:
            return {
                ...state,
                newErpAgent: {...action.payload}
            };
        case ERP_AGENT_REORDER:
            return {
                ...state,
                order:   action.payload.order,
                orderBy: action.payload.orderBy
            };
        case FETCH_ERP_AGENTS:
            return {
                ...state,
                erpAgents: [...action.payload],
                updatedAt: new Date()
            };
        case FETCH_MAPPED_ERP_CLIENTS:
            return {
                ...state,
                erpClients:     [...action.payload.data],
                erpClientsMeta: {...action.payload.meta}
            };
        case FETCH_MAPPED_ERP_TECHNICIANS:
            return {
                ...state,
                erpTechnicians:     [...action.payload.data],
                erpTechniciansMeta: {...action.payload.meta}
            };
        case SET_ERP_AGENT:
            return {
                ...state,
                selectedAgent: { ...action.payload }
            };
        case SET_ERP_AGENT_LOADING:
            return {
                ...state,
                erpAgentLoading: action.payload
            };
        case SET_CUSTOMERS_LOADING:
            return {
                ...state,
                customersLoading: action.payload
            };
        case SET_CUSTOMER_SEARCH_VALUE:
            return {
                ...state,
                customerSearchValue: action.payload
            };
        case SET_CUSTOMER_TRACKING_LOADING:
            return {
                ...state,
                customerTrackingLoading: action.payload
            };
        case SET_ERP_AGENTS_LOADING:
            return {
                ...state,
                erpAgentsLoading: action.payload
            };
        case SET_TECHNICIANS_LOADING:
            return {
                ...state,
                techniciansLoading: action.payload
            };
        case SET_TECHNICIAN_SEARCH_VALUE:
            return {
                ...state,
                technicianSearchValue: action.payload
            };
        case SET_TECHNICIAN_TRACKING_LOADING:
            return {
                ...state,
                technicianTrackingLoading: action.payload
            };
        default:
            return state;
    }
};
